<template>
    <div>
        <header v-show="rule.typeRule && rule.ruleConfigs && rule.ruleConfigs.length > 0"
            text="Regra aplicada aos seguintes valores:"></header>
        <v-data-table
            v-show="rule.typeRule && !viewOnly"
            :headers="headersEdit"
            :items.sync="rule.ruleConfigs"
            :footer-props="{
                'items-per-page-options': [5]
            }"
            :items-per-page="5"
            disable-sort
            hide-default-header
            no-data-text="Regra aplicada para todos."
        >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" v-if="!viewOnly"
                @click="deleteItem(item)">
                mdi-trash-can
              </v-icon>
            </template>
        </v-data-table>

        <v-data-table
            v-show="rule.typeRule && viewOnly"
            :headers="headersView"
            :items.sync="rule.ruleConfigs"
            :footer-props="{
                'items-per-page-options': [5]
            }"
            :items-per-page="5"
            disable-sort
            hide-default-header
            no-data-text="Regra aplicada para todos."
        >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" v-if="!viewOnly"
                @click="deleteItem(item)">
                mdi-trash-can
              </v-icon>
            </template>
        </v-data-table>

    </div>
</template>
<script>
export default {
  name: 'tableRuleConfigs',
  props: {
    viewOnly: Boolean,
    rule: {},
  },

  data: () => ({
    headersEdit: [
      { text: 'Ações', value: 'actions' },
      { text: 'Descrição', value: 'descriptionEntityTypeRule' },
    ],
    headersView: [
      { text: 'Descrição', value: 'descriptionEntityTypeRule' },
    ],
  }),

  methods: {
    deleteItem(item) {
      this.$emit('deleteItem', item);
    },

  },
};
</script>
<style scoped>
  p {
      border: 1px;
  }
</style>
